import React, { useCallback, useState } from 'react'
import useTranslation from 'next-translate/useTranslation'
import { get, map } from 'lodash'
import { copyToClipboardAsTable } from 'tennders-stracture/libs/utils'
// icons
import { useToast } from 'tennders-common/hooks/useToast'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons'
import IconCopy from '../../../../../icons/icon-copy.svg'

const LoadDetailsTable = ({ shipments }) => {
  const { t } = useTranslation()
  const { toastSuccess } = useToast()
  const headers = ['brand', 'plates', 'carType', 'chassis']
  const headersTranslations = headers.map(x => t('transaction:' + x))
  const [isListCollapsed, setIsListCollapsed] = useState(true)

  const copyContent = useCallback(() => {
    copyToClipboardAsTable(headers, shipments, headersTranslations)
    toastSuccess(t('common:copied'))
  }, [shipments])

  return (
    <>
      <div className="d-flex justify-space mb-16" onClick={() => setIsListCollapsed(!isListCollapsed)}>
        <span className="bold" style={{ fontSize: '13px' }}>{t('transaction:loadDetails')}:</span>
        <FontAwesomeIcon icon={isListCollapsed ? faChevronUp : faChevronDown} className="cursor-pointer" />
      </div>
      {isListCollapsed && (
        <>
          {/* if the length is more than 10, table overflows and we need to adjust header according to scrollbar width */}
          <div className={'tennders-grid-5-col p-10 pr-0' + (get(shipments, 'length') > 10 ? ' mr-8' : '')}>
            <div className="column-1">{t('transaction:brand')}</div>
            <div className="column-1">{t('transaction:plates')}</div>
            <div className="column-1">{t('transaction:car_type')}</div>
            <div className="column-2 d-flex justify-space">
              {t('transaction:chassis')}
              <span style={{ marginTop: '-3px' }}>
                <IconCopy className="cursor-pointer" onClick={copyContent} />
              </span>
            </div>
          </div>
          <div className="tennders-table-responsive tennders-custom-scroll load-details-table">
            {get(shipments, 'length') > 0 && (
              map(shipments, x => map(x.items, shipment => (
                <div className="tennders-grid-5-col">
                  <div className="column-1">{get(shipment, 'brandName') || '-'}</div>
                  <div className="column-1">{get(shipment, 'plateNumber') || '-'}</div>
                  <div className="column-1">{get(shipment, 'modelName') || '-'}</div>
                  <div className="column-2">{get(shipment, 'chassis') || '-'}</div>
                </div>
              )))
            )}
          </div>
        </>
      )}
    </>
  )
}

export default React.memo(LoadDetailsTable)
